import React from 'react';

import { CREATE_TALENT_NOTE, DELETE_TALENT_NOTE, GET_TALENT_NOTES, UPDATE_TALENT_NOTE } from '../../../gql/talents';
import { EntityNotesContent, EntityNotesManager } from '../../notes/components/EntityNotesManager';

interface NotesManagerProps {
    open?: boolean;
    onClose?: () => void;
    talentId: string;
    talentName?: string;
    variant?: 'dialog' | 'embedded';
}

const talentNotesConfig = {
    title: 'Notes sur le talent',
    subTitle: "Seuls les membres de votre groupe peuvent voir les commentaires.",
    operations: {
        listQuery: GET_TALENT_NOTES,
        createMutation: CREATE_TALENT_NOTE,
        updateMutation: UPDATE_TALENT_NOTE,
        deleteMutation: DELETE_TALENT_NOTE,
        listDataPath: 'getTalentNotesUpercut',
        createDataPath: 'createTalentNoteUpercut',
        updateDataPath: 'updateTalentNoteUpercut',
    },
    variableBuilder: {
        list: ({ entityId }) => ({ talentId: entityId }),
        create: ({ entityId, input }) => ({ talentId: entityId, input }),
        update: ({ entityId, noteId, input }) => ({ talentId: entityId, noteId, input }),
        delete: ({ entityId, noteId }) => ({ talentId: entityId, noteId }),
    },
};

export const NotesManager: React.FC<NotesManagerProps> = ({
    open = false,
    onClose = () => undefined,
    talentId,
    talentName,
    variant = 'dialog',
}) => {
    if (variant === 'embedded') {
        return (
            <EntityNotesContent
                entityId={talentId}
                entityName={talentName}
                title={talentNotesConfig.title}
                subTitle={talentNotesConfig.subTitle}
                operations={talentNotesConfig.operations}
                variableBuilder={talentNotesConfig.variableBuilder}
            />
        );
    }

    return (
        <EntityNotesManager
            open={open}
            onClose={onClose}
            entityId={talentId}
            entityName={talentName}
            title={talentNotesConfig.title}
            subTitle={talentNotesConfig.subTitle}
            operations={talentNotesConfig.operations}
            variableBuilder={talentNotesConfig.variableBuilder}
        />
    );
};
